/**
 * Help-center search gap logging (settle timer).
 *
 * The help center searches on every keystroke (debounced). We only want to log the query the
 * user ended up with, so each search result restarts a settle timer; when it fires with no newer
 * result, the query and its hit count are handed to `log`. The same settled query is logged at
 * most once per logger instance (one help-center visit).
 */

export const HELP_SEARCH_SETTLE_MS = 2500;
const MIN_CHARS = 3;

function normalizeKey(query) {
    return query.trim().toLowerCase().replace(/\s+/g, ' ');
}

export function createHelpSearchLogger({ log, delayMs = HELP_SEARCH_SETTLE_MS }) {
    let timer = null;
    const logged = new Set();

    const cancel = () => {
        if (timer) {
            clearTimeout(timer);
            timer = null;
        }
    };

    const onSearchResult = (query, hits) => {
        cancel();
        const search = String(query || '').trim();
        if (search.length < MIN_CHARS) {
            return;
        }
        const key = normalizeKey(search);
        const hitCount = Number.isFinite(Number(hits)) && Number(hits) > 0 ? Math.floor(Number(hits)) : 0;
        timer = setTimeout(() => {
            timer = null;
            if (logged.has(key)) {
                return;
            }
            logged.add(key);
            log({ search, hits: hitCount });
        }, delayMs);
    };

    return { onSearchResult, cancel };
}
